<template>
	<div class="warehouse-entry">
		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0"
					v-if="filtershow">
					<el-form-item>
						<el-select v-model="formfilter.state" placeholder="全部状态" clearable>
							<el-option label="全部状态" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="v in stateList" :key="v.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="zk" @click="filtershow = !filtershow">
				<span>{{ filtershow ? '收起' : '展开' }}</span>
			</div>
			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column prop="id" label="批次" align="center" header-align="center" width="70px"></el-table-column>
					<el-table-column prop="seller_username" label="卖家" align="center" header-align="center" min-width="90px"></el-table-column>
					<el-table-column prop="warehouse_name" label="云仓" align="center" header-align="center" min-width="110px"></el-table-column>
					<el-table-column prop="state_str" label="状态" align="center" header-align="center" width="90px">
						<template slot-scope="scope">
							<span :class="'state-' + scope.row.state">{{ scope.row.state_str }}</span>
						</template>
					</el-table-column>
					<el-table-column label="明细摘要" align="center" header-align="center" min-width="220px">
						<template slot-scope="scope">
							<div class="summary-text">{{ formatSummary(scope.row) }}</div>
							<div class="summary-styles" v-if="summaryStyles(scope.row)">{{ summaryStyles(scope.row) }}</div>
							<div v-if="rejectBadgeText(scope.row)" :class="'reject-badge reject-badge-' + rejectState(scope.row)">{{ rejectBadgeText(scope.row) }}</div>
						</template>
					</el-table-column>
					<el-table-column prop="create_time_str" label="申请时间" align="center" header-align="center" width="160px"></el-table-column>
					<el-table-column label="审核/物流" align="center" header-align="center" min-width="160px">
						<template slot-scope="scope">
							<div v-if="scope.row.state == 2">拒绝：{{ scope.row.audit_remark || '-' }}</div>
							<div v-if="scope.row.shipping_name">{{ scope.row.shipping_name }} {{ scope.row.shipping_tracking_no }}</div>
							<div v-if="scope.row.shipping_time_str">{{ scope.row.shipping_time_str }}</div>
							<div v-if="scope.row.audit_time_str && scope.row.state != 2">审核：{{ scope.row.audit_time_str }}</div>
							<div v-if="scope.row.reject_shipping_name">退回：{{ scope.row.reject_shipping_name }} {{ scope.row.reject_tracking_no }}</div>
							<div v-if="scope.row.reject_ship_time_str">寄出：{{ scope.row.reject_ship_time_str }}</div>
							<div v-if="scope.row.reject_confirm_time_str">确认收货：{{ scope.row.reject_confirm_time_str }}</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" fixed="right" align="center" header-align="center" width="160px">
						<template slot-scope="scope">
							<div class="operation_i">
								<span @click="openDetail(scope.row)">详情</span>
								<span v-if="scope.row.state == 0" @click="openAudit(scope.row)">审核</span>
								<span v-if="scope.row.state == 3" @click="openInspect(scope.row)">验收</span>
								<span v-if="rejectState(scope.row) == 1" @click="openRejectShip(scope.row)">退回不合格品</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="pagediv">
				<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
					:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
					@current-change="handleCurrentChange" @size-change="handleSizeChange">
				</el-pagination>
			</div>
		</div>

		<el-dialog :title="'入仓详情 · 批次 ' + (currentDetail.id || '')" :visible.sync="detailShow" width="860px" :before-close="closeDetail">
			<div class="detail-box" v-if="detailShow">
				<div class="detail-meta">
					<div><span>卖家</span>{{ currentDetail.seller_username || '-' }}</div>
					<div><span>云仓</span>{{ currentDetail.warehouse_name || '-' }}</div>
					<div><span>状态</span><em :class="'state-' + currentDetail.state">{{ currentDetail.state_str || '-' }}</em></div>
					<div><span>申请时间</span>{{ currentDetail.create_time_str || '-' }}</div>
					<div><span>摘要</span>{{ formatSummary(currentDetail) }}</div>
				</div>
				<div class="detail-extra" v-if="currentDetail.state == 2">拒绝：{{ currentDetail.audit_remark || '-' }}</div>
				<div class="detail-extra" v-if="currentDetail.shipping_name">
					物流：{{ currentDetail.shipping_name }} {{ currentDetail.shipping_tracking_no }}
					<template v-if="currentDetail.shipping_time_str"> · {{ currentDetail.shipping_time_str }}</template>
				</div>
				<div class="detail-extra" v-if="currentDetail.audit_time_str && currentDetail.state != 2">
					审核：{{ currentDetail.audit_time_str }}
				</div>
				<div class="detail-extra" v-if="currentDetail.state == 4 && currentDetail.inspect_time_str">
					验收：{{ currentDetail.inspect_time_str }}
					<template v-if="currentDetail.inspect_remark"> · {{ currentDetail.inspect_remark }}</template>
				</div>
				<div class="detail-extra" v-if="rejectBadgeText(currentDetail)" :class="'reject-badge-' + rejectState(currentDetail)">
					{{ rejectBadgeText(currentDetail) }}
				</div>
				<div class="detail-extra" v-if="currentDetail.reject_shipping_name">
					退回物流：{{ currentDetail.reject_shipping_name }} {{ currentDetail.reject_tracking_no }}
					<template v-if="currentDetail.reject_ship_time_str"> · {{ currentDetail.reject_ship_time_str }}</template>
				</div>
				<div class="detail-extra" v-if="currentDetail.reject_confirm_time_str">
					确认收货：{{ currentDetail.reject_confirm_time_str }}
				</div>
				<div class="detail-images" v-if="detailImages.length">
					<img v-for="(url, i) in detailImages" :key="i" :src="url" @click="previewImage(url)">
				</div>
				<el-table :data="detailGroups" border size="mini" style="width: 100%">
					<el-table-column prop="style_number" label="款号" width="140" align="center" header-align="center"></el-table-column>
					<el-table-column label="综合拿货折扣" width="120" align="center" header-align="center">
						<template slot-scope="scope">{{ formatCompositeDiscount(itemCompositeDiscount(scope.row)) }}</template>
					</el-table-column>
					<el-table-column label="综合拿货价" width="110" align="center" header-align="center">
						<template slot-scope="scope">¥{{ fenToYuan(itemCompositeCost(scope.row)) }}</template>
					</el-table-column>
					<el-table-column label="尺码明细" min-width="280" align="left" header-align="center">
						<template slot-scope="scope">
							<div class="size-chip" v-for="item in scope.row.sizes" :key="item.id">
								<strong>{{ item.size }}</strong>
								申请{{ item.apply_quantity }}
								<template v-if="currentDetail.state == 4">
									· 实收{{ item.received_quantity }} · 不合格{{ item.rejected_quantity }} · 入仓{{ item.net_quantity }}
								</template>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button v-if="currentDetail.state == 0" type="primary" @click="openAuditFromDetail">审核</el-button>
				<el-button v-if="currentDetail.state == 3" type="primary" @click="openInspectFromDetail">验收</el-button>
				<el-button v-if="rejectState(currentDetail) == 1" type="primary" @click="openRejectShipFromDetail">退回不合格品</el-button>
				<el-button @click="closeDetail">关闭</el-button>
			</div>
		</el-dialog>

		<el-dialog :title="'审核入仓 · 批次 ' + (currentAudit.id || '')" :visible.sync="auditShow" width="720px" :before-close="closeAudit">
			<div class="detail-box" v-if="auditShow">
				<div class="detail-meta">
					<div><span>卖家</span>{{ currentAudit.seller_username || '-' }}</div>
					<div><span>预冻结试算</span>¥{{ fenToYuan(batchAmount(currentAudit)) }}</div>
				</div>
				<p class="form-tip">通过后按综合拿货价预冻结保证金；拒绝将回补卖家渠道库存。抽点已计入综合拿货价，不单独展示。</p>
				<el-table :data="auditGroups" border size="mini" style="width: 100%" max-height="280">
					<el-table-column prop="style_number" label="款号" width="140" align="center" header-align="center"></el-table-column>
					<el-table-column label="综合拿货折扣" width="120" align="center" header-align="center">
						<template slot-scope="scope">{{ formatCompositeDiscount(itemCompositeDiscount(scope.row)) }}</template>
					</el-table-column>
					<el-table-column label="综合拿货价" width="110" align="center" header-align="center">
						<template slot-scope="scope">¥{{ fenToYuan(itemCompositeCost(scope.row)) }}</template>
					</el-table-column>
					<el-table-column label="尺码明细" min-width="220" align="left" header-align="center">
						<template slot-scope="scope">
							<div class="size-chip" v-for="item in scope.row.sizes" :key="item.id">
								<strong>{{ item.size }}</strong>申请{{ item.apply_quantity }}
							</div>
						</template>
					</el-table-column>
				</el-table>
				<el-form class="audit-form" label-width="80px">
					<el-form-item label="备注">
						<el-input type="textarea" v-model="auditRemark" :rows="2" placeholder="拒绝时必填"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeAudit">取消</el-button>
				<el-button type="danger" :loading="auditing" @click="onAudit(2)">拒绝</el-button>
				<el-button type="primary" :loading="auditing" @click="onAudit(1)">通过</el-button>
			</div>
		</el-dialog>

		<el-dialog :title="'入仓验收 · 批次 ' + (currentInspect.id || '')" :visible.sync="inspectShow" width="900px" :before-close="closeInspect">
			<div class="detail-box" v-if="inspectShow">
				<div class="detail-meta">
					<div><span>卖家</span>{{ currentInspect.seller_username || '-' }}</div>
					<div><span>预冻结（综合拿货价）</span>¥{{ fenToYuan(batchAmount(currentInspect)) }}</div>
					<div><span>验收后入仓价值</span>¥{{ fenToYuan(inspectAmount) }}</div>
				</div>
				<p class="form-tip">默认按申请数全收。只提交改过的行，未改动行后端按全收处理。入仓数 = 实收 − 不合格。差额调整按综合拿货价。</p>
				<el-table :data="inspectLines" border size="mini" style="width: 100%" max-height="320">
					<el-table-column prop="style_number" label="款号" width="120" align="center" header-align="center"></el-table-column>
					<el-table-column prop="size" label="尺码" width="70" align="center" header-align="center"></el-table-column>
					<el-table-column label="申请" width="70" align="center" header-align="center">
						<template slot-scope="scope">{{ scope.row.apply_quantity }}</template>
					</el-table-column>
					<el-table-column label="综合拿货价" width="110" align="center" header-align="center">
						<template slot-scope="scope">¥{{ fenToYuan(itemCompositeCost(scope.row)) }}</template>
					</el-table-column>
					<el-table-column label="实收" width="110" align="center" header-align="center">
						<template slot-scope="scope">
							<el-input-number v-model="scope.row.received_quantity" :min="0" :max="scope.row.apply_quantity" :precision="0" :controls="false" size="mini"></el-input-number>
						</template>
					</el-table-column>
					<el-table-column label="不合格" width="110" align="center" header-align="center">
						<template slot-scope="scope">
							<el-input-number v-model="scope.row.rejected_quantity" :min="0" :max="scope.row.received_quantity" :precision="0" :controls="false" size="mini"></el-input-number>
						</template>
					</el-table-column>
					<el-table-column label="入仓" width="70" align="center" header-align="center">
						<template slot-scope="scope">{{ inspectNet(scope.row) }}</template>
					</el-table-column>
				</el-table>
				<el-form class="audit-form" label-width="80px">
					<el-form-item label="备注">
						<el-input type="textarea" v-model="inspectRemark" :rows="2" placeholder="选填"></el-input>
					</el-form-item>
					<el-form-item label="图片">
						<div class="img-list">
							<div class="img-item" v-for="(url, i) in inspectImages" :key="i">
								<img :src="url" @click="previewImage(url)">
								<i class="el-icon-close" @click="removeImage(i)"></i>
							</div>
							<myupload v-if="inspectImages.length < 6" :uptype="1" @resultUrl="onInspectImg"></myupload>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeInspect">取消</el-button>
				<el-button type="primary" :loading="inspecting" @click="onInspect">确认验收</el-button>
			</div>
		</el-dialog>

		<el-dialog title="退回不合格品" :visible.sync="rejectShow" width="480px" :before-close="closeRejectShip">
			<div class="forms" v-if="rejectShow">
				<p class="form-tip">运费线下协商，系统只记录物流。不合格品不回补渠道库存。</p>
				<el-form ref="rejectForm" :model="rejectForm" :rules="rejectRules" label-width="100px">
					<el-form-item label="快递公司" prop="shipping_name">
						<el-input v-model="rejectForm.shipping_name" placeholder="请输入快递公司"></el-input>
					</el-form-item>
					<el-form-item label="物流单号" prop="shipping_tracking_no">
						<el-input v-model="rejectForm.shipping_tracking_no" placeholder="请输入物流单号"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeRejectShip">取消</el-button>
				<el-button type="primary" :loading="rejecting" @click="onRejectShip">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { fenToYuan, apiMsg, formatCompositeDiscount, itemCompositeCost, itemCompositeDiscount } from './money.js'

	export default {
		name: 'WarehouseEntry',
		inject: ['appdata'],
		data() {
			return {
				filtershow: true,
				formfilter: {
					state: ''
				},
				stateList: [
					{ id: 0, name: '待审核' },
					{ id: 1, name: '通过' },
					{ id: 2, name: '拒绝' },
					{ id: 3, name: '待验收' },
					{ id: 4, name: '已验收' }
				],
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,
				detailShow: false,
				currentDetail: {},
				queryOpened: false,
				auditShow: false,
				auditing: false,
				currentAudit: {},
				auditRemark: '',
				inspectShow: false,
				inspecting: false,
				currentInspect: {},
				inspectLines: [],
				inspectRemark: '',
				inspectImages: [],
				rejectShow: false,
				rejecting: false,
				currentReject: {},
				rejectForm: {
					shipping_name: '',
					shipping_tracking_no: ''
				},
				rejectRules: {
					shipping_name: [{ required: true, message: '请输入快递公司', trigger: 'blur' }],
					shipping_tracking_no: [{ required: true, message: '请输入物流单号', trigger: 'blur' }]
				}
			}
		},
		computed: {
			detailGroups() {
				return this.groupItems(this.currentDetail.items)
			},
			auditGroups() {
				return this.groupItems(this.currentAudit.items)
			},
			detailImages() {
				var images = this.currentDetail.inspect_images
				if (Array.isArray(images)) {
					return images
				}
				if (typeof images === 'string' && images) {
					try {
						var parsed = JSON.parse(images)
						return Array.isArray(parsed) ? parsed : []
					} catch (e) {
						return []
					}
				}
				return []
			},
			inspectAmount() {
				var self = this
				return this.inspectLines.reduce(function(sum, row) {
					return sum + itemCompositeCost(row) * self.inspectNet(row)
				}, 0)
			}
		},
		mounted() {
			if (this.$route.query.state === '0' || this.$route.query.state === '3') {
				this.formfilter.state = Number(this.$route.query.state)
			}
			this.onlist()
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect
					this.$refs.tablediv.style.height = 'calc(100% - ' + (Number(cr.height) + 30) + 'px)'
				}
			})
			if (this.$refs.filter) {
				this.resizeObserver.observe(this.$refs.filter)
			}
		},
		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect()
			}
		},
		methods: {
			fenToYuan: fenToYuan,
			formatCompositeDiscount: formatCompositeDiscount,
			itemCompositeCost: itemCompositeCost,
			itemCompositeDiscount: itemCompositeDiscount,
			rejectState(row) {
				return Number((row && row.reject_state) || 0)
			},
			rejectedTotal(row) {
				return Number((row && row.rejected_total) || 0)
			},
			rejectBadgeText(row) {
				var st = this.rejectState(row)
				var n = this.rejectedTotal(row)
				if (st == 1) {
					return '不合格 ' + n + ' 件待退回'
				}
				if (st == 2) {
					return (row && row.reject_state_str) || '退回中'
				}
				if (st == 3) {
					return (row && row.reject_state_str) || '已退回'
				}
				return ''
			},
			refreshBalance() {
				if (this.appdata && this.appdata.oninfo) {
					this.appdata.oninfo()
				}
			},
			batchSummary(row) {
				var items = (row && row.items) || []
				var styles = {}
				var qty = 0
				var amount = 0
				items.forEach(function(item) {
					if (item.style_number) {
						styles[item.style_number] = true
					}
					qty += Number(item.apply_quantity || 0)
					amount += itemCompositeCost(item) * Number(item.apply_quantity || 0)
				})
				return {
					productCount: Object.keys(styles).length,
					skuCount: items.length,
					qty: qty,
					amount: amount
				}
			},
			batchAmount(row) {
				return this.batchSummary(row).amount
			},
			formatSummary(row) {
				var s = this.batchSummary(row)
				var text = s.productCount + '款 / ' + s.skuCount + '尺码 / 共' + s.qty + '件 / ¥' + this.fenToYuan(s.amount)
				if (row && row.state == 4) {
					var net = ((row.items || [])).reduce(function(sum, item) {
						return sum + Number(item.net_quantity || 0)
					}, 0)
					text += ' / 入仓' + net + '件'
				}
				return text
			},
			summaryStyles(row) {
				var names = []
				var seen = {}
				;((row && row.items) || []).forEach(function(item) {
					if (item.style_number && !seen[item.style_number]) {
						seen[item.style_number] = true
						names.push(item.style_number)
					}
				})
				if (!names.length) {
					return ''
				}
				if (names.length <= 2) {
					return names.join('、')
				}
				return names.slice(0, 2).join('、') + ' 等' + names.length + '款'
			},
			groupItems(items) {
				var map = {}
				var order = []
				;(items || []).forEach(function(item) {
					var key = item.style_number || item.product_id || item.id
					if (!map[key]) {
						map[key] = {
							style_number: item.style_number,
							discount: item.discount,
							unit_cost: item.unit_cost,
							composite_discount: item.composite_discount,
							composite_cost: item.composite_cost,
							sizes: []
						}
						order.push(map[key])
					}
					map[key].sizes.push(item)
				})
				return order
			},
			inspectNet(row) {
				var received = Number(row.received_quantity || 0)
				var rejected = Number(row.rejected_quantity || 0)
				return Math.max(0, received - rejected)
			},
			openDetail(row) {
				this.currentDetail = row || {}
				this.detailShow = true
			},
			closeDetail() {
				this.detailShow = false
				this.currentDetail = {}
			},
			openAuditFromDetail() {
				var row = this.currentDetail
				this.closeDetail()
				this.openAudit(row)
			},
			openInspectFromDetail() {
				var row = this.currentDetail
				this.closeDetail()
				this.openInspect(row)
			},
			openRejectShipFromDetail() {
				var row = this.currentDetail
				this.closeDetail()
				this.openRejectShip(row)
			},
			openRejectShip(row) {
				this.currentReject = row || {}
				this.rejectForm = {
					shipping_name: '',
					shipping_tracking_no: ''
				}
				this.rejectShow = true
				this.$nextTick(() => {
					if (this.$refs.rejectForm) {
						this.$refs.rejectForm.clearValidate()
					}
				})
			},
			closeRejectShip() {
				this.rejectShow = false
				this.currentReject = {}
			},
			onRejectShip() {
				this.$refs.rejectForm.validate((valid) => {
					if (!valid) {
						return
					}
					this.rejecting = true
					this.$axios.post('api/cloud_warehouse/entry_reject_ship', {
						batch_id: this.currentReject.id,
						shipping_name: this.rejectForm.shipping_name,
						shipping_tracking_no: this.rejectForm.shipping_tracking_no
					}).then(res => {
						this.rejecting = false
						if (res.data.code === 0) {
							this.$message.success('退回物流已提交')
							this.closeRejectShip()
							this.onlist()
						} else {
							this.$message.error(apiMsg(res))
						}
					}).catch(err => {
						this.rejecting = false
						console.log(err)
					})
				})
			},
			openAudit(row) {
				this.currentAudit = row || {}
				this.auditRemark = ''
				this.auditShow = true
			},
			closeAudit() {
				this.auditShow = false
				this.currentAudit = {}
				this.auditRemark = ''
			},
			openInspect(row) {
				this.currentInspect = row || {}
				this.inspectRemark = ''
				this.inspectImages = []
				this.inspectLines = ((row && row.items) || []).map(function(item) {
					return {
						id: item.id,
						style_number: item.style_number,
						size: item.size,
						apply_quantity: Number(item.apply_quantity || 0),
						unit_cost: item.unit_cost,
						discount: item.discount,
						composite_cost: item.composite_cost,
						composite_discount: item.composite_discount,
						received_quantity: Number(item.apply_quantity || 0),
						rejected_quantity: 0
					}
				})
				this.inspectShow = true
			},
			closeInspect() {
				this.inspectShow = false
				this.currentInspect = {}
				this.inspectLines = []
				this.inspectRemark = ''
				this.inspectImages = []
			},
			onInspectImg(url) {
				if (url) {
					this.inspectImages.push(url)
				}
			},
			removeImage(index) {
				this.inspectImages.splice(index, 1)
			},
			previewImage(url) {
				window.open(url)
			},
			tryOpenQueryBatch() {
				var id = this.$route.query.batch_id
				if (!id || this.queryOpened) {
					return
				}
				var row = this.list.filter(function(item) {
					return String(item.id) === String(id)
				})[0]
				if (row) {
					this.queryOpened = true
					if (row.state == 0) {
						this.openAudit(row)
					} else if (row.state == 3) {
						this.openInspect(row)
					} else if (this.rejectState(row) == 1) {
						this.openRejectShip(row)
					} else {
						this.openDetail(row)
					}
				}
			},
			onfilter() {
				this.page = 1
				this.onlist()
			},
			onreset() {
				this.formfilter = { state: '' }
				this.page = 1
				this.onlist()
			},
			handleCurrentChange() {
				this.onlist()
			},
			handleSizeChange(val) {
				this.page = 1
				this.pageSize = val
				this.onlist()
			},
			onlist() {
				var params = {
					page: this.page,
					limit: this.pageSize,
					role: 'buyer'
				}
				if (this.formfilter.state !== '' && this.formfilter.state !== null) {
					params.state = this.formfilter.state
				}
				this.$axios.get('api/cloud_warehouse/entry_list', { params: params }).then(res => {
					if (res.data.code === 0) {
						var data = res.data.data || {}
						this.list = data.list || []
						this.total = data.count || 0
						this.tryOpenQueryBatch()
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					console.log(err)
				})
			},
			onAudit(state) {
				if (!this.currentAudit.id) {
					return
				}
				if (state == 2 && !String(this.auditRemark || '').trim()) {
					this.$message.warning('拒绝时请填写备注')
					return
				}
				this.auditing = true
				this.$axios.post('api/cloud_warehouse/entry_audit', {
					batch_id: this.currentAudit.id,
					state: state,
					audit_remark: this.auditRemark
				}).then(res => {
					this.auditing = false
					if (res.data.code === 0) {
						if (state == 1) {
							this.$message.success('保证金已预冻结')
						} else {
							this.$message.success('已拒绝，渠道库存将回补')
						}
						this.closeAudit()
						this.refreshBalance()
						this.onlist()
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					this.auditing = false
					console.log(err)
				})
			},
			onInspect() {
				if (!this.currentInspect.id) {
					return
				}
				var payload = []
				for (var i = 0; i < this.inspectLines.length; i++) {
					var row = this.inspectLines[i]
					var received = Number(row.received_quantity || 0)
					var rejected = Number(row.rejected_quantity || 0)
					var applyQty = Number(row.apply_quantity || 0)
					if (received < 0 || rejected < 0) {
						this.$message.warning('验收数量不能为负数')
						return
					}
					if (received > applyQty) {
						this.$message.warning('实收数量不能超过申请数量（款号：' + row.style_number + '）')
						return
					}
					if (rejected > received) {
						this.$message.warning('不合格数量不能超过实收数量（款号：' + row.style_number + '）')
						return
					}
					if (received !== applyQty || rejected !== 0) {
						payload.push({
							entry_id: Number(row.id),
							received_quantity: received,
							rejected_quantity: rejected
						})
					}
				}
				var data = {
					batch_id: this.currentInspect.id,
					items: JSON.stringify(payload)
				}
				if (this.inspectRemark) {
					data.inspect_remark = this.inspectRemark
				}
				if (this.inspectImages.length) {
					data.inspect_images = JSON.stringify(this.inspectImages)
				}
				this.inspecting = true
				this.$axios.post('api/cloud_warehouse/entry_inspect', data).then(res => {
					this.inspecting = false
					if (res.data.code === 0) {
						this.$message.success('验收完成')
						this.closeInspect()
						this.refreshBalance()
						this.onlist()
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					this.inspecting = false
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.warehouse-entry {
		height: 100%;
	}

	.tablebox {
		height: 100%;
	}

	.summary-text {
		line-height: 20px;
	}

	.summary-styles {
		font-size: 12px;
		color: #909399;
		line-height: 18px;
	}

	.reject-badge {
		font-size: 12px;
		line-height: 18px;
		margin-top: 2px;
	}

	.reject-badge-1 { color: #E6A23C; }
	.reject-badge-2 { color: #409EFF; }
	.reject-badge-3 { color: #909399; }

	.detail-meta {
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 12px;
		div {
			width: 50%;
			line-height: 26px;
			span {
				display: inline-block;
				width: 70px;
				color: #909399;
			}
			em {
				font-style: normal;
			}
		}
	}

	.detail-extra,
	.form-tip {
		margin-bottom: 8px;
		color: #606266;
		font-size: 13px;
	}

	.form-tip {
		color: #909399;
	}

	.size-chip {
		display: inline-block;
		margin: 2px 12px 2px 0;
		line-height: 22px;
		strong {
			margin-right: 4px;
		}
	}

	.audit-form {
		margin-top: 12px;
	}

	.detail-images,
	.img-list {
		display: flex;
		flex-wrap: wrap;
		align-items: flex-start;
		margin-bottom: 12px;
	}

	.detail-images img,
	.img-item img {
		width: 72px;
		height: 72px;
		object-fit: cover;
		margin-right: 8px;
		margin-bottom: 8px;
		cursor: pointer;
	}

	.img-item {
		position: relative;
		margin-right: 8px;
		.el-icon-close {
			position: absolute;
			top: -4px;
			right: 0;
			cursor: pointer;
			background: #fff;
			border-radius: 50%;
		}
	}

	.state-0 { color: #E6A23C; }
	.state-1 { color: #409EFF; }
	.state-2 { color: #F56C6C; }
	.state-3 { color: #409EFF; }
	.state-4 { color: #67C23A; }

	/deep/ .el-input-number {
		width: 72px;
	}

	/deep/ .el-input-number .el-input__inner {
		padding: 0 4px;
		text-align: center;
	}
</style>



// WEBPACK FOOTER //
// src/components/buyer/warehouse/entry.vue